var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zoom-overlay__wrapper",on:{"wheel":_vm.wheelListener}},[_c('v-fade-transition',[(_vm.shown)?_c('div',{staticClass:"zoom-overlay"},[_c('span',{staticClass:"zoom-overlay__text"},[_vm._v(_vm._s(_vm.$t('common.ctrlZoom')))])]):_vm._e()]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }